import { useCallback } from 'react';
// Hooks.
// -----------------------------------------------------------------------------
export const useInputNumber = ({ name }) => {
    // Handlers.
    // ---------------------------------------------------------------------------
    const handleDecrement = useCallback(() => {
        const node = document.getElementById(`input-number-${name}`);
        if (node) {
            node.stepDown();
            node.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }, [name]);
    const handlerIncrement = useCallback(() => {
        const node = document.getElementById(`input-number-${name}`);
        if (node) {
            node.stepUp();
            node.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }, [name]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        onDecrement: handleDecrement,
        onIncrement: handlerIncrement
    };
};
//# sourceMappingURL=InputNumber.hooks.js.map